var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDotWhiteResidencia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127.907,
    height: 127.939,
    viewBox: "0 0 127.907 127.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.051,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff005d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-dot-white-residencia",
    transform: "translate(2.279 2.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(-2.279 -2.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_340",
    "data-name": "Caminho 340",
    className: "cls-1",
    d: "M60.623-2.072a4.994,4.994,0,0,1,.935-.083,2.242,2.242,0,0,1,.986.169c2.578,1.043,2.64,5.61,2.6,8.035A53.886,53.886,0,0,1,100.8,22.336a53.946,53.946,0,0,1,16.3,35.642c.7,0,3.706-.01,4.3,0a3.5,3.5,0,0,1,3.723,3.512,3.549,3.549,0,0,1-3.733,3.643c-.622.019-3.661,0-4.3,0a53.923,53.923,0,0,1-16.289,35.651,53.866,53.866,0,0,1-35.642,16.3c0,.734.019,3.783,0,4.417a3.575,3.575,0,1,1-7.149-.006c-.022-.66,0-3.741,0-4.417a53.98,53.98,0,0,1-35.645-16.3A53.884,53.884,0,0,1,6.073,65.1c-.192.021-1.371.028-3.36,0-2.146-.01-3.706-.267-4.668-2.587a2.218,2.218,0,0,1-.14-.972c.038-.812.14-.939.14-.939.521-1.894,2.408-2.617,4.668-2.587.03-.007,2.941-.046,3.364,0A53.951,53.951,0,0,1,22.413,22.294,53.9,53.9,0,0,1,57.937,6.043c.033-2.891-.184-7.509,2.692-8.121ZM36.045,65.143C37.264,76.775,47.725,86.2,57.911,87.028c.019-.035.054-.07.054-.105.016-1.71.013-3.42.048-5.13a3.572,3.572,0,1,1,7.143-.089c.054,1.783.01,3.567.01,5.36,11.239-1.1,21-11.316,21.895-21.93-1.672,0-3.337.016-5,0-2.338-.026-3.914-1.493-3.9-3.6.013-2.128,1.563-3.538,3.93-3.554,1.665-.013,3.327,0,5,0-1.12-11.5-11.581-21.069-21.927-21.9-2.044-.425-3.231-.675-7.159-.048-10.174.389-22.858,13.716-21.959,21.968,1.739,0,3.6-.029,5.35,0a3.438,3.438,0,0,1,3.5,2.673,3.521,3.521,0,0,1-3.484,4.466c-1.78.054-3.567.01-5.36.01Zm29.188,44.645C91.2,108.071,109.189,85.6,109.68,65.226H94.6c-3.1,16.557-12.828,26.288-29.363,29.341ZM57.966,94.423A33.276,33.276,0,0,1,28.7,65.245H13.369c1.739,26.106,24.354,43.917,44.6,44.412Zm51.8-36.5C108.547,34.274,88.088,14.443,65.23,13.4V28.525C81.813,31.6,91.553,41.363,94.6,57.92h15.163Zm-81.215.01c3.091-16.628,12.857-26.368,29.373-29.4V13.359c-24.642,1.5-43.64,22.686-44.463,44.574h15.09Z",
    transform: "translate(2.283 2.832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_341",
    "data-name": "Caminho 341",
    className: "cls-2",
    d: "M168.752,162.819c1.125,0,2.133-.016,3.138,0a2.884,2.884,0,0,1,3.059,2.881,2.917,2.917,0,0,1-3.064,2.986c-1,.021-2.01,0-3.132,0,0,1.042.008,2.01,0,2.975a2.948,2.948,0,1,1-5.872.024c-.008-.945,0-1.889,0-3-1.12,0-2.214.037-3.3-.008a2.9,2.9,0,0,1-2.766-3.807,2.836,2.836,0,0,1,2.787-2.049c1.041-.029,2.086-.005,3.284-.005,0-1-.005-1.968,0-2.931.013-2,1.193-3.308,2.957-3.287a2.953,2.953,0,0,1,2.915,3.24c.01.945,0,1.887,0,2.975Z",
    transform: "translate(-101.949 -101.369)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2715",
    "data-name": "Ret\\xE2ngulo 2715",
    className: "cls-2",
    width: 47.508,
    height: 7.309,
    rx: 3.654,
    transform: "translate(0 60.719)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2716",
    "data-name": "Ret\\xE2ngulo 2716",
    className: "cls-2",
    width: 47.508,
    height: 7.309,
    rx: 3.654,
    transform: "translate(80.399 60.719)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2717",
    "data-name": "Ret\\xE2ngulo 2717",
    className: "cls-2",
    width: 47.508,
    height: 7.309,
    rx: 3.654,
    transform: "translate(60.208 47.508) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2718",
    "data-name": "Ret\\xE2ngulo 2718",
    className: "cls-2",
    width: 47.508,
    height: 7.309,
    rx: 3.654,
    transform: "translate(60.208 127.907) rotate(-90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDotWhiteResidencia);
export default __webpack_public_path__ + "static/media/icon-dot-white-residencia.b0e754b7861314e18d5aabfa285029fe.svg";
export { ForwardRef as ReactComponent };